<template>
	<div style="background-color: #f1f1f1;">

		<div class="head">
			<div class="pcImg">
				<img src="@/assets/headImg/head.jpg" style="width: 100%;" />
			</div>
			<div class="phoneImg">
				<img src="../../../assets/phoneSchedule/top.jpg" alt="" style="width: 100%;">
			</div>

			<div class="retrun_pc" @click="retrun_home">返回</div>


			<div class="video_box">
				<video src="../../../assets/花絮05.19.mp4" :controls="videoOptions.controls"
					class="video-js vjs-big-play-centered vjs-fluid" webkit-playsinline="true" playsinline="true"
					x-webkit-airplay="allow" x5-playsinline style="width: 100%;" @play="onPlayerPlay"
					@pause="onPlayerPause" @seeking="seeking" autoplay="false" ref="video">
				</video>
				<div class="tc">
					
				</div>
			</div>
			<div class="btn-box" :class="$route.path == '/signIn'? 'ishow':''">
				<div class="retrun_phone" @click="retrun_home">返回首页</div>
			</div>
		</div>

	</div>

</template>

<script>
	export default {
		name: "showVideo",

		data() {
			return {
				videoOptions: {
					controls: true,
					src: "", // url地址
				},
				player: null,
				playTime: '',
				seekTime: '',
				current: '',
				seeking: '',
			}
		},
		beforeRouteLeave() {
			//
		},
		mounted() {
			this.initVideo();
		},
		methods: {
			retrun_home() {
				this.$router.back();
				setTimeout(() => {
					location.reload();
				}, 100)
			},
			initVideo() {
				//原生初始化视频方法
				let myVideo = this.$refs.video;

				//ontimeupdate
				myVideo.ontimeupdate = function() {
					myFunction()
				};
				let _this = this;

				function myFunction() {
					let playTime = myVideo.currentTime
					setTimeout(function() {
						localStorage.setItem("cacheTime", playTime)
					}, 500)
					let time = localStorage.getItem("cacheTime")
					// 当前播放位置发生变化时触发。
					if (playTime - Number(time) > 2) {
						myVideo.currentTime = Number(time)
					} else {}
				};
			},
			// 播放回调
			onPlayerPlay(player) {
				// this.globalSetting = true
				console.log("player play!", player);
				// document.getElementsByClassName("vjs-control-bar").style.display = "block";
				// document.getElementsByClassName("vjs-control-bar").style.display = "block";
			},
			onPlayerPause(player) {
				// this.globalSetting.controls = false;
				// console.log("player pause!", player);
				// var video = document.getElementById("video");
				// video.controls=false;
				// document.getElementsByClassName("vjs-control-bar").style.display = "none";
			},
			beforeDestroy() {
				if (this.player) {
					this.player.dispose()
				}
			}
		},

	}
</script>

<style>
	.retrun_phone {
		/* 	font-size: 20px;
		font-weight: bold;
		color: #1e65ff;
		text-align: center;
		margin-bottom: 30px;
		background-color: #eeeeee; */
		margin: 0 auto;
		line-height: 40px;
		text-align: center;
		background-color: #5e89ff;
		color: #fff;
		border-radius: 5px;
		width: 80%;
		/* margin-bottom: 20px; */
		position: fixed;
		bottom: 20px;
		margin-left: 50%;
		transform: translateX(-50%);

	}

	.btn-box {
		position: fixed;
		margin-left: 50%;
		transform: translateX(-50%);
		width: 100%;
		background-color: #fff;
		bottom: 0;
		height: 50px;
	}

	.head {
		width: 980px;
		margin: 0 auto;
	}

	.retrun_pc {
		margin: 20px 0;
		cursor: pointer;
		color: rgb(20, 90, 245);
		font-size: 1.125rem;
		font-weight: bold;
		display: inline-block;
	}

	.retrun_pc:hover {
		color: #49a8eb;
	}

	.pcImg {
		display: none;
	}

	@media (max-width: 500px) {
		.head {
			width: 100%;
			margin: 0 auto;
		}

		.retrun_pc {
			display: none;
		}
		
		.video_box {
			margin-top: 1.25rem;
		}
	}


	@media (min-width:31.25rem) {
		.btn-box {
			display: none;
		}

		.retrun_phone {
			display: none;
		}

		.flex {
			display: none;
		}

		.pcImg {
			display: block;
		}

		.phoneImg {
			display: none;
		}

		.video_box {
			margin-top: 5px;
			
		}
		.tc {
			width: 100vw;
			height: 133px;
			background-color: #f1f1f1;
		}
	}
</style>
